import axios from 'axios'
import axiosRetry from 'axios-retry'
import { store } from '../../redux/store'

export const deliveryClient = axios.create({
  baseURL: `${process.env.REACT_APP_DELIVERY_URL}`
})

axiosRetry(deliveryClient, {
  retries: 0,
  retryDelay: retryCount => retryCount * 1000,
  retryCondition: error => axiosRetry.isNetworkError(error) || axiosRetry.isRetryableError(error)
})

deliveryClient.interceptors.request.use(
  config => {
    const token = (store.getState() as any)?.session?.authentication?.token
    return {
      ...config,
      headers: {
        ...config.headers,
        'X-Token': token
      }
    }
  },
  error => Promise.reject(error)
)
